import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var Card = function (_a) {
    var _b = _a.component, component = _b === void 0 ? "div" : _b, _c = _a.elevation, elevation = _c === void 0 ? "0" : _c, as = _a.as, _d = _a.themeKey, themeKey = _d === void 0 ? "card" : _d, sx = _a.sx, className = _a.className, props = __rest(_a, ["component", "elevation", "as", "themeKey", "sx", "className"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(__assign({ look: "solid", elevation: elevation, tone: "white", sx: sx }, props), {
        themeKey: themeKey,
    });
    return jsx(Box, __assign({ as: as || component, className: className }, forwardProps));
};
Card.displayName = "Card";

export { Card };
//# sourceMappingURL=Card.js.map
